const normalizeCategoryIdValue = (value) => {
    if (!value) return null;
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
        return value.id || value._id || null;
    }
    return null;
};

export const getTemplateCategoryIds = (template) => {
    const rawValues = [
        ...(Array.isArray(template?.categoryIds) ? template.categoryIds : []),
        ...(template?.categoryId ? [template.categoryId] : []),
    ];

    const seen = new Set();
    const categoryIds = [];

    rawValues.forEach((value) => {
        const normalizedId = normalizeCategoryIdValue(value);
        if (!normalizedId || seen.has(normalizedId)) return;
        seen.add(normalizedId);
        categoryIds.push(normalizedId);
    });

    return categoryIds;
};

export const getPrimaryTemplateCategoryId = (template) => getTemplateCategoryIds(template)[0] || null;

export const templateHasCategory = (template, categoryId) => {
    if (!categoryId) return false;
    return getTemplateCategoryIds(template).includes(String(categoryId));
};

export const getTemplateCategoryLabels = (template, categoryMap = {}) => getTemplateCategoryIds(template)
    .map((categoryId) => categoryMap[categoryId])
    .filter(Boolean);